import Hidden from './hiddenTemplate'

export default -> {
  hidden: Hidden
}